import { c as _c } from "react/compiler-runtime";
import { createContext, type Dispatch, type PropsWithChildren, useContext, useReducer } from 'react';
import { type ConversationsState, initialConversationsState } from './context';
import { conversationReducer } from './reducers/conversationsReducer';
interface ConversationsContextInterface {
  dispatch: Dispatch<any>;
  state: ConversationsState;
}
const ConversationsContext = createContext<ConversationsContextInterface>({
  state: initialConversationsState,
  dispatch: () => {}
});
export const useConversationsState = () => {
  return useContext(ConversationsContext);
};
export const ConversationsContextProvider = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [state, dispatch] = useReducer(conversationReducer, initialConversationsState);
  let t1;
  if ($[0] !== state) {
    t1 = {
      state,
      dispatch
    };
    $[0] = state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <ConversationsContext.Provider value={t1}>{children}</ConversationsContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};